import dayjs from "dayjs";
import type { ClientPortfolioReportingInterpolatedRangeResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export type InterpolatedPeriod = {
	from: Date;
	to: Date;
	fromLabel: string;
	toLabel: string;
};

const MONTH_KEY_PATTERN = /^\d{4}-\d{2}$/;

const toMonthStart = (monthKey: string) => {
	if (!MONTH_KEY_PATTERN.test(monthKey)) {
		return null;
	}

	const parsed = dayjs(`${monthKey}-01`);

	return parsed.isValid() ? parsed : null;
};

export const parseInterpolatedPeriods = (
	ranges: ClientPortfolioReportingInterpolatedRangeResponseDTO[] | undefined,
): InterpolatedPeriod[] => {
	if (!ranges || ranges.length === 0) {
		return [];
	}

	const periods: InterpolatedPeriod[] = [];

	for (const range of ranges) {
		const from = toMonthStart(range.from);
		const to = toMonthStart(range.to);

		if (from === null || to === null || to.isBefore(from)) {
			continue;
		}

		periods.push({
			from: from.toDate(),
			to: to.endOf("month").toDate(),
			fromLabel: from.format("MM.YYYY"),
			toLabel: to.format("MM.YYYY"),
		});
	}

	return periods;
};

export const findInterpolatedPeriod = (
	periods: InterpolatedPeriod[],
	date: Date | number | string | null | undefined,
): InterpolatedPeriod | undefined => {
	if (periods.length === 0 || date === null || date === undefined) {
		return undefined;
	}

	const time = new Date(date).getTime();

	if (Number.isNaN(time)) {
		return undefined;
	}

	return periods.find(
		(period) => time >= period.from.getTime() && time <= period.to.getTime(),
	);
};
